<template>
  <div id="app">
    <router-view v-if='isAlive'></router-view>
  </div>
</template>

<script>
	export default {
	    name: 'App',
	    provide () {
	    	return {
	    		reload: this.reload
	    	}
	    },

	    data () {
	    	return {
	    		isAlive: true
	    	}
	    },

		methods: {
			reload () {
				this.isAlive = false
				this.$nextTick(function() {
					this.isAlive = true
				})
			}
		}
	};
</script>
<style rel="stylesheet/less" lang="less" scoped>
   
</style>



// WEBPACK FOOTER //
// src/App.vue